export const UNDEFINED = 0;
export const MAIN_FORMULA = 1;
export const LOCAL_FORMULA = 2;
export const MODIFIED_MAIN_FORMULA = 3;
export const MODIFIED_LOCAL_FORMULA = 4;
export const QUICK_TINT = 5;
export const MANUAL_CORRECTION = 6;
export const ORDER = 7;
export const AUTOMATIC_CORRECTION = 8;
export const FINISHED_CORRECTION = 9;
export const REFORMULATION = 10;
export const LOCAL_FORMULA_MATCHING = 11;
export const MODIFIED_AUTOMATIC_CORRECTION = 12;

export const STAT_TYPES = [
    MAIN_FORMULA,
    LOCAL_FORMULA,
    MODIFIED_MAIN_FORMULA,
    MODIFIED_LOCAL_FORMULA,
    QUICK_TINT,
    MANUAL_CORRECTION,
    ORDER,
    AUTOMATIC_CORRECTION,
    FINISHED_CORRECTION,
    REFORMULATION,
    LOCAL_FORMULA_MATCHING,
    MODIFIED_AUTOMATIC_CORRECTION
];
